// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"a7e3a709","193":"50dfc6c1","237":"2b6244b3","258":"1ba1a7d2","336":"3fd8d568","453":"9f8dace2","507":"72b07c80","737":"13da69cd","743":"f5e3b18a","971":"1b6a6995"}[chunkId] + ".chunk.js";
};